enum Theme {
  Default = 'DEFAULT',
  Dark = 'DARK',
}

export default Theme
